// extracted by mini-css-extract-plugin
module.exports = {"VideoBlock":"VideoBlock_VideoBlock__RBFJj","VideoBlock--Small":"VideoBlock_VideoBlock--Small__2q5lO"};